import { useState, useEffect } from 'react'
import { clsx } from 'clsx'

/**
 * Banner shown when the browser goes offline.
 * Automatically hides when connection is restored.
 */
export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine)

  useEffect(() => {
    const goOffline = () => setIsOffline(true)
    const goOnline = () => setIsOffline(false)

    window.addEventListener('offline', goOffline)
    window.addEventListener('online', goOnline)

    return () => {
      window.removeEventListener('offline', goOffline)
      window.removeEventListener('online', goOnline)
    }
  }, [])

  if (!isOffline) return null

  return (
    <div
      role="alert"
      className={clsx(
        'fixed top-0 left-0 right-0 z-[300] safe-area-pt',
        'bg-amber-500 text-white text-center text-sm py-2 px-4',
        'animate-in fade-in slide-in-from-top-2 duration-300'
      )}
    >
      Нет соединения с интернетом
    </div>
  )
}
